var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show())?_c('div',{staticClass:"brackets__schedule-button"},[_c('button',{staticClass:"button button-primary",attrs:{"disabled":!_vm.hasPermission('Tournament edit', _vm.tournament.getGameId())},on:{"click":_vm.openScheduleDialog}},[_vm._v(_vm._s(_vm.$t('Update schedule')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }